const baseStyle = {
  container: {
    borderRadius: 'base'
  },
  title: {
    fontSize: 'md',
    fontWeight: 'semibold',
    lineHeight: 'base'
  },
  description: {
    fontSize: 'md',
    fontWeight: 'normal',
    lineHeight: 'base'
  },
  icon: {
    mr: '3'
  }
}

const variantInfo = {
  container: { bg: 'var(--vndly-color-feedback-background-info)' },
  icon: { color: 'var(--vndly-color-feedback-icon-info)' }
}

const variantSuccess = {
  container: { bg: 'var(--vndly-color-feedback-background-success)' },
  icon: { color: 'var(--vndly-color-feedback-icon-success)' }
}

const variantWarning = {
  container: { bg: 'var(--vndly-color-feedback-background-warning)' },
  icon: { color: 'var(--vndly-color-feedback-icon-warning)' }
}

const variantDanger = {
  container: { bg: 'var(--vndly-color-feedback-background-danger)' },
  icon: { color: 'var(--vndly-color-feedback-icon-danger)' }
}

const variantActionBar = {
  container: {
    bg: 'var(--vndly-color-feedback-background-info)',
    color: 'system.color.fg.strong'
  }
}

const staticVariants = {
  info: variantInfo,
  success: variantSuccess,
  warning: variantWarning,
  error: variantDanger
}

const variantSystem = props => ({
  ...staticVariants[props.status],
  container: {
    ...staticVariants[props.status]?.container,
    alignItems: 'flex-start',
    position: 'relative',
    zIndex: -1,
    rounded: 0,
    justifyContent: 'center',
    '> div': {
      flex: 'initial'
    }
  }
})

const variantWarningList = {
  container: {
    bg: 'none',
    borderLeft: '6px solid var(--vndly-color-input-border-warned)',
    borderRadius: 0
  },
  icon: { color: 'var(--vndly-color-input-border-warned)' }
}

const variantErrorList = {
  container: {
    bg: 'none',
    borderLeft: '6px solid var(--chakra-colors-red-600)',
    borderRadius: 0
  },
  icon: { color: 'red.600' }
}

export const Alert = {
  baseStyle,
  variants: {
    info: variantInfo,
    success: variantSuccess,
    warning: variantWarning,
    error: variantDanger,
    actionBar: variantActionBar,
    system: variantSystem,
    'list-warning': variantWarningList,
    'list-error': variantErrorList
  }
}
